import {Promise} from "bluebird";
import {apiRequest} from "./ApiRequest";

const getRias = params => {
    return apiRequest("get", "/rias", null, params).then(response => {
        return Promise.resolve(response.data);
    });
};

const getRiaDetails = ria => {
    return apiRequest("get", "/rias/" + ria.id).then(response => {
        return Promise.resolve(response.data);
    });
};

const editRia = (id, data) => {
    // By using an array of promises and Promise.allSettled we can ensure the new logo is updated, and old logos are deleted
    // prior to resolving the promise. This allows the site header logo to update without requiring an additional
    // page refresh.
    return apiRequest("put", "/rias/" + id, data).then(response => {
        const promises = [];
        if (data.addedFiles.length) {
            const formData = new FormData();
            data.addedFiles.forEach(f => {
                formData.append("upload", f);
            });
            promises.push(apiRequest("post", `/rias/${response.data.id}/logo`, formData));
        }
        if (data.deletedFiles) {
            promises.push(...(data.deletedFiles.map(df => apiRequest("delete", df.src))));
        }
        return Promise.allSettled(promises).then(() => {
            return response.data;
        });
    });
};

const createRia = data => {
    return apiRequest("post", "/rias", data).then(response => {
        if (data.addedFiles.length) {
            const formData = new FormData();
            data.addedFiles.forEach(f => {
                formData.append("upload", f);
            });
            return apiRequest("post", `/rias/${response.data.id}/logo`, formData).then(() => Promise.resolve(response.data));
        }
        return Promise.resolve(response.data);
    });
};

const deleteRia = id => {
    return apiRequest("delete", "/rias/" + id).then(response => {
        return Promise.resolve(response.data);
    });
};

const getRiaWithholdingWalletsByToken = (id, custodianId, token, force) => {
    if (!id) {
        return Promise.reject(new Error("Missing account info"));
    }
    return apiRequest("get", `/rias/${id}/custodians/${custodianId}/withholdingWallets/${token}`, null, {_force: force}).then(response => {
        return Promise.resolve(response.data);
    });
};

const editRiaWithholdingWallets = (id, custodianId, data) => {
    if (!id) {
        return Promise.reject(new Error("Missing account info"));
    }
    return apiRequest("put", `/rias/${id}/custodians/${custodianId}/withholdingWallets`, data).then(response => {
        return Promise.resolve(response.data);
    });
};

export {
    getRias,
    getRiaDetails,
    editRia,
    createRia,
    deleteRia,
    getRiaWithholdingWalletsByToken,
    editRiaWithholdingWallets
};
